<template>
    <b-modal v-model="feedbackModalVisibility" :close-on-backdrop="false" :hide-close="true" position="center"
                    :title="tr(`Feedback & Suggestions|Commentaires et suggestions`)">
        <b-form>
            <div class="text-center">
                <i class="fa-comment-smile text-primary fa-3x mb-2" :class="fontAwesomePrefix"
                   style="opacity: 0.75" />
            </div>

            <div class="rounded bg-white p-2 mb-3">
                <p class="f-11" v-if="tr(cmsWebsite.settings.testing.testersMessage)">{{tr(cmsWebsite.settings.testing.testersMessage)}}</p>
                <template v-else>
                    <p class="f-10" v-tr>Thank you for testing the Wayfinder application.|Merci de tester notre application de navigation.</p>
                </template>
            </div>

            <b-form-group>
                <template #label>
                    <span class="f-11">{{$t('map.assistant.subject')}} *</span>
                </template>
                <b-select v-model="feedback.issue" required>
                    <optgroup :label="tr(`Experience & User Interface|Interface et expérience utilisateur`)">
                        <option value="ux-suggest-missing-feature" v-tr>Suggest new feature|Suggérer une nouvelle fonctionnalité</option>
                        <option value="hard-to-read" v-tr>Element hard to read|Élément difficile à lire</option>
                    </optgroup>
                    <optgroup :label="tr(`Directory & Search|Répertoire et recherche`)">
                        <option value="directory-improvement" v-tr>Suggest Directory Improvement|Suggérer amélioration du répertoire</option>
                        <option value="content-need-update" v-tr>Content Need Update|Le contenu a besoin de mise à jour</option>
                        <option value="missing-destination" v-tr>Destination missing or incorrect|Destination manquante ou incorrecte</option>
                        <option value="missing-keywords" v-tr>Missing Search Keywords|Mots-clés manquants pour la recherche</option>
                    </optgroup>
                    <optgroup :label="tr(`Map|Plan`)">
                        <option value="map-improvement" v-tr>Suggest Map Improvement|Suggérer amélioration du plan</option>
                        <option value="map-destination-image-wrong" v-tr>Destination Image is wrong|L'image de destination n'est pas bonne</option>
                        <option value="map-location-is-wrong" v-tr>Point is not at the good location|Cette destination n'est pas au bon endroit</option>
                    </optgroup>
                    <optgroup :label="tr(`Navigation & Route|Navigation et route`)">
                        <option value="navigation-suggestion" v-tr>Suggest Navigation Improvement|Suggérer des améliorations pour la navigation</option>
                        <option value="unclear-instructions" v-tr>Instructions not clear or missing|Instructions pas claires ou manquantes</option>
                        <option value="image-obsolete">{{ $t('map.assistant.issueOptions.imageObsolete') }}</option>
                        <option value="image-missing">{{ $t('map.assistant.issueOptions.imageMissing') }}</option>
                        <option value="under-construction" v-tr>Construction or inaccessible zone|Construction ou zone non accessible</option>
                        <option value="elevator-required-but-not-offered" v-tr>Elevator required but not offered|Ascenseur requis mais non offer</option>
                        <option value="route-not-accessible-wheelchair" v-tr>Route not accessible for wheelchair|Itinéraire not accessible PMR</option>
                    </optgroup>
                    <optgroup :label="tr(`Issues|Problèmes`)">
                        <option value="page-issue" v-tr>Page not loading or too slow|Page ne charge pas ou trop lente</option>
                        <option value="button-issue" v-tr>Button/link not working as expected|Bouton/lien ne fonctionne pas comme prévu</option>
                        <option value="cannot-go-to-next">{{ $t('map.assistant.issueOptions.cannotGoNext') }}</option>
                        <option value="cannot-end-navigation">{{ $t('map.assistant.issueOptions.cannotEndNavigation') }}</option>
                        <option value="action-missing" v-tr>Button/link not working as expected|Bouton/lien ne fonctionne pas comme prévu</option>
                        <option value="bug-or-issue" v-tr>Other bug or issue|Autre bug ou problème</option>
                    </optgroup>
                    <option value="comment" v-tr>Comment|Commentaire</option>
                    <option value="other">{{ $t('map.assistant.issueOptions.other') }}</option>
                    <option value="test">{{ $t('map.assistant.issueOptions.test') }}</option>
                </b-select>
            </b-form-group>
            <b-form-group>
                <template #label>
                    <span class="f-11">Description</span>
                </template>
                <b-textarea v-model="feedback.message" :placeholder="$t('map.assistant.commentDescription')"
                            no-resize style="height: 120px;"/>
            </b-form-group>
            <b-form-group :label="tr(`Attach Screenshot|Ajouter une capture d'écran`)">
                <e-file-input v-model="feedback.screenshot" @change="onImageChanged" class="mb-0" theme="light" size="sm" type="image" inline allow-empty base64/>
            </b-form-group>
            <b-form-group :label="$t('map.assistant.email')">
                <b-input-group>
                    <b-input-group-text><i class="fa-envelope" :class="fontAwesomePrefix" />
                    </b-input-group-text>
                    <b-form-input type="email" v-model="feedback.email" placeholder="Ex: john.doe@email.com" />
                </b-input-group>
            </b-form-group>
            <b-checkbox v-model="feedback.contactMe">
                <span class="f-11" v-tr>Allow to contact me|Autoriser à me contacter</span>
            </b-checkbox>
        </b-form>
        <template #modal-footer="{ close }">
            <b-btn variant="light" class="action-btn" @click="close">
                {{ $t('map.assistant.cancel') }}
            </b-btn>
            <b-btn variant="accent" class="action-btn" :disabled="!feedback.issue" @click="sendFeedback">
                <span v-tr>Send|Envoyer</span>
            </b-btn>
        </template>
    </b-modal>
</template>

<script>
import EMobileModal from './e-mobile-modal.vue';
import Feedback from "../../common/db/models/core/Feedback.js";
import SessionTracker from "@/helpers/SessionTracker.js";
import NetworkV2 from "@vue-components/helpers/NetworkV2.js";
import {swal} from "vue-swal";
import EFileInput from "@vue-components/components/e-file-input.vue";
import FileHelper from "@vue-components/helpers/FileHelper.js";

export default {
    name: `modal-feedback`,
    components: {EFileInput, EMobileModal },
    computed: {
        feedbackModalVisibility: {
            get() {
                return this.$store.state.feedbackModal.visible;
            },
            set(value) {
                this.$store.state.feedbackModal.visible = value;
            }
        }
    },
    data() {
        return {
            feedback: {
                visible: false,
                issue: ``,
                message: ``,
                contactMe: false,
                email: ``
            }
        }
    },
    mounted() {
        this.feedback.email = localStorage.getItem(`feedbackEmail`);
        this.feedback.contactMe = localStorage.getItem(`feedbackContactMe`) === `true`;
    },
    methods: {
        async sendFeedback() {
            this.showLoading();
            const errorFeedback = new Feedback({
                project: `cms-editor`,
                type: `tests`,
                dealerid: this.dealerid,
                message: this.feedback.message,
                issue: this.feedback.issue,
                contactMe: this.feedback.contactMe,
                screenshot: this.feedback.screenshot,
                email: this.feedback.email,
                websiteId: this.cmsWebsite.id,
                sessionId: SessionTracker.session?.id,
                url: window.location.href
            });

            localStorage.setItem(`feedbackEmail`, this.feedback.email);
            localStorage.setItem(`feedbackContactMe`, this.feedback.contactMe);

            if (this.$store.state.feedbackModal.data) {
                for (let key in this.$store.state.feedbackModal.data) {
                    if (errorFeedback[key]) {
                        console.error(`key ${key} already exist for feedback Modal`)
                        continue;
                    }
                    errorFeedback[key] = this.$store.state.feedbackModal.data[key];
                }
            }

            await NetworkV2.post(`/api/public/feedback/send`, errorFeedback);
            this.feedback.message = ``;
            this.feedbackModalVisibility = false;
            swal({
                title: this.$t(`map.assistant.thankYou`),
                text: this.$t(`map.assistant.valuableFeedback`),
                icon: `success`
            });
        },
        onImageChanged(image) {
            if (!image.startsWith(`data:image`)) {
                swal({
                    title: this.tr(`Invalid Image|Image non valide`),
                    text: this.tr(`Please make sure to upload a valid image|Merci de vérifier que votre image est valide`),
                    icon: `error`
                })
                feedback.screenshot = null;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
